import { userContext } from '../userManager';
import { getStartAndEndDateByTag } from '../../utils/dates';

export const apiPortfoliosGet = () =>
  userContext.apiCall({
    url: `/portfolios`,
  });

export const apiPortfoliosHoldingsGet = (portfolioId) =>
  userContext.apiCall({
    url: `/portfolios/${portfolioId}/holdings`,
  });

export const apiPortfoliosDetailsGet = (portfolioId) =>
  userContext.apiCall({
    url: `/portfolios/${portfolioId}`,
  });

export const apiPortfoliosPerformanceGet = (portfolioId, { benchmarkId, yearsTag, compareIds }) => {
  let startDate;
  if (yearsTag) {
    startDate = getStartAndEndDateByTag(yearsTag).startDate;
  }
  return userContext.apiCall({
    url: `/portfolios/${portfolioId}/performances`,
    qs: {
      compareInstrumentIds: compareIds ?? '',
      benchmarkId,
      startDate,
    },
  });
};

export const apiPortfoliosKpisGet = (portfolioId, { yearsTag, startDate, endDate }) => {
  let newStartDate = startDate;
  let newEndDate = endDate;

  if (yearsTag) {
    const dates = getStartAndEndDateByTag(yearsTag);
    newStartDate = dates.startDate;
    newEndDate = dates.endDate;
  }

  return userContext.apiCall({
    url: `/portfolios/${portfolioId}/kpis`,
    qs: {
      startDate: newStartDate,
      endDate: newEndDate,
    },
  });
};

export const apiPortfolioWalletsGet = (portfolioId) =>
  userContext.apiCall({
    url: `/portfolios/${portfolioId}/wallets`,
  });
